import React, { useRef, useState, useEffect } from 'react';
import VBLeaflet from '@vb-js-commons/new/vbLeaflet';
import Modal from 'react-bootstrap/Modal';
import VBInput from "@vb-js-commons/new/vbInput";
import VBMultiOption from "@vb-js-commons/new/vbMultiOption";
import { useAuctions } from '../../pages/auctions/context/AuctionsContext';
import { ZoomAndLayerButtons, LayerSelector } from '../mapComponents/MapComponents';

let fields = [
    {
        id: 'al',
        label: 'Al',
    },
    {
        id: 'asp',
        label: 'Asp',

    },
    {
        id: 'björk',
        label: 'Björk',
    },
    {
        id: 'bok',
        label: 'Bok',
    },
    {
        id: 'ek',
        label: 'Ek',
    },
];

const Step2 = () => {
    const { adData, changeAdData } = useAuctions();
    
    const [gallring, setGallring] = useState(adData.arrangement == "gallring");
    const [currentSectionData, setCurrentSectionData] = useState([]);
    const [errors, setErrors] = useState(false);
    const [selectedSection, setSelectedSection] = useState(0);
    const [volume, setVolume] = useState(null);
    const [volumeNew, setVolumeNew] = useState(null);
    const [volume_m3fub, setVolumeM3Fub] = useState(null);
    const [volume_m3fub_new, setVolumeM3FubNew] = useState(null);
    const [tall, setTall] = useState(0);
    const [gran, setGran] = useState(0);
    const [lov, setLov] = useState(0);
    const [al, setAl] = useState(0);
    const [asp, setAsp] = useState(0);
    const [björk, setBjork] = useState(0);
    const [bok, setBok] = useState(0);
    const [ek, setEk] = useState(0);
    const [avdelningsnr, setAvdelningsnr] = useState(null);
    const [area, setArea] = useState(null);
    const [fieldSelected, setFieldSelected] = useState(null);
    const [mapTools, setMapTools] = useState(false);
    const [refresh, setRefresh] = useState(false);
    // Modals
    const [editSectionModal, setEditSectionModal] = useState(false);
    const [addSectionModal, setAddSectionModal] = useState(false);
    const [deleteSectionModal, setDeleteSectionModal] = useState(false);
    const [isMenuRowOpen, setIsMenuRowOpen] = useState(null);

    // Refs
    const mapRef = useRef();
    const adLayersRef = useRef(L.featureGroup([]));
    const menuRef = useRef()
    const volumeM3skInputRef = useRef();
    const volumeM3FubInputRef = useRef();
    const volumeM3skInputNewRef = useRef();
    const volumeM3FubInputNewRef = useRef();


    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target) && isMenuRowOpen !== null) {
            setIsMenuRowOpen(null)
        }
    }

    const addGeojsonToMap = (geojson) => {
        let sections = L.featureGroup([])
        L.geoJSON(geojson, {
            interactive: true,
            style: (feature) => {
                return {
                    color: "#ffff00",
                };
            },
            onEachFeature: (feature, layer) => {
                if (layer.options.alt == "Marker") {
                    layer.options.type = "marker"
                }
                sections.addLayer(layer)

            },
        })
        mapRef.current.setLayers(sections)
        sections.addTo(mapRef.current.state.map)
    }

    useEffect(() => {
        window.addEventListener('click', handleClickOutside);
        window.scrollTo({ top: 700, behavior: 'smooth' });

        // Initial map and data loading logic
        const initializeMapAndData = () => {
            if (adData.adLayers.length > 0) {
                const group = L.featureGroup([]);
                let currentFeatNum = 1;
                const updatedAdLayers = [];
                const updatedForestWithSections = JSON.parse(JSON.stringify(adData.forestWithSections)); // Deep copy
                adData.adLayers.forEach((itm) => {
                    itm.layer.addTo(group);
                    if (!itm.layer.hasOwnProperty("_icon")) {
                        addLabel({ label: currentFeatNum.toString(), location: itm.layer.getBounds().getCenter() });
             
                        if (updatedForestWithSections && updatedForestWithSections.sections[currentFeatNum - 1]) {
                            updatedForestWithSections.sections[currentFeatNum - 1].Name = currentFeatNum.toString();
                        }
                                         
                        updatedAdLayers.push({
                            data: {
                                ...itm.data,
                                tall: itm.data.tall / 100,
                                gran: itm.data.gran / 100,
                                lov: itm.data.lov ?? itm.data.default, 
                                id: itm.layer._leaflet_id,
                                al: (itm.data.al !== undefined && itm.data.al !== null) ? itm.data.al / 100 : undefined,
                                asp: (itm.data.asp !== undefined && itm.data.asp !== null) ? itm.data.asp / 100 : undefined,
                                björk: (itm.data.björk !== undefined && itm.data.björk !== null) ? itm.data.björk / 100 : undefined,
                                bok: (itm.data.bok !== undefined && itm.data.bok !== null) ? itm.data.bok / 100 : undefined,
                                ek: (itm.data.ek !== undefined && itm.data.ek !== null) ? itm.data.ek / 100 : undefined,
                                name: (currentFeatNum).toString(), 
                            },
                        });
                        
                        currentFeatNum++;
                    }
                });
                changeAdData({ forestWithSections: updatedForestWithSections });  
                setCurrentSectionData(updatedAdLayers);
                if (mapRef.current && mapRef.current.state && mapRef.current.state.map) {
                    mapRef.current.state.map.fitBounds(group.getBounds());
                    addGeojsonToMap(group.toGeoJSON());
                }
                

            } else if (Object.keys(adData.forestWithSections).length > 0) {
                const data = adData.forestWithSections.sections.map((section) => ({
                    data: {
                        area: section.Hectares,
                        volume: section.totalVolume,
                        volume_m3fub: section.totalVolume,
                        tall: section.TGL.Tall,
                        gran: section.TGL.Gran,
                        lov: section.TGL.Lov ?? section.TGL.default,
                        id: section.Name,
                        al: section.TGL.Al,
                        asp: section.TGL.Asp,
                        björk: section.TGL.Björk,
                        bok: section.TGL.Bok,
                        ek: section.TGL.Ek,
                        name: section.Name,
                    }
                }));
                setCurrentSectionData(data);

                setTimeout(() => {
                    if (adData.custom_area) {
                        const geoLayer = L.geoJSON(adData.custom_area, { color: "#ffff00" });
                        geoLayer.addTo(adLayersRef.current);
                        geoLayer.bringToFront();
                        if (mapRef.current && mapRef.current.state && mapRef.current.state.map) {
                            mapRef.current.setLayers(adLayersRef.current);
                            adLayersRef.current.addTo(mapRef.current.state.map);
                            mapRef.current.state.map.fitBounds(adLayersRef.current.getBounds());
                        }
                    }
                }, 200);
            }
        };

        const timeoutId = setTimeout(initializeMapAndData, 200);

        return () => {
            window.removeEventListener('click', handleClickOutside);
            clearTimeout(timeoutId);
        };
    },[]); 

    useEffect(() => {
        if (Object.keys(adData.forestWithSections).length > 0) {
            const data = adData.forestWithSections.sections.map((section) => ({
                data: {
                    area: section.Hectares,
                    volume: section.totalVolume,
                    volume_m3fub: section.totalVolume,
                    tall: section.TGL.Tall,
                    gran: section.TGL.Gran,
                    lov: section.TGL.Lov ?? section.TGL.default,
                    al: section.TGL.Al,
                    asp: section.TGL.Asp,
                    björk: section.TGL.Björk,
                    bok: section.TGL.Bok,
                    ek: section.TGL.Ek,
                    id: section.Name,
                    name: section.Name,
                },
            }));
            setCurrentSectionData(data);
        }

    }, [adData.forestWithSections])

    useEffect(() => {
        const allAreZero = [tall, lov, gran, al, asp, björk, bok, ek].every(val => val === 0);
        if (!allAreZero) {
            validateTGL();
        }
    }, [tall, lov, gran, al, asp, björk, bok, ek]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuRowOpen(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
 
    useEffect(() => {
        if (refresh) setRefresh(false);
    }, [refresh]);

    {/* Helpers */ }
    const capitalizeFirstLetter = ((str) => {
        if (typeof str !== 'string' || !str.length) return str;
        return str[0] === str[0].toLowerCase() ? (str.charAt(0).toUpperCase() + str.slice(1)) : str;
    });
 
    const handleMenuClick = (index, e) => {
        e.stopPropagation();
        setIsMenuRowOpen(prev => (prev === index ? null : index));
    }

    const addLabel = (itm) => {
        setTimeout(() => {
            let lblCenter = L.latLng(itm.location)
            const labelContent = document.createElement('div');
            labelContent.innerHTML = itm.label;

            const label = new L.tooltip({
                className: "white bg-transparent border-0 shadow-none fs-2",
                direction: "center",
                permanent: true,
                opacity: 1

            })
            label.setLatLng(lblCenter);
            label.setContent(labelContent);
            label.options.type = "marker"
            mapRef.current.setLayer(label)
            label.addTo(mapRef.current.state.map);
        }, 50)

    }

    const validateTGL = () => {
        const tallVal = Math.abs(parseInt(tall)) || 0;
        const lovVal = Math.abs(parseInt(lov)) || 0;
        const granVal = Math.abs(parseInt(gran)) || 0;
        const alVal = Math.abs(parseInt(al)) || 0;
        const aspVal = Math.abs(parseInt(asp)) || 0;
        const bjorkVal = Math.abs(parseInt(björk)) || 0;
        const bokVal = Math.abs(parseInt(bok)) || 0;
        const ekVal = Math.abs(parseInt(ek)) || 0;

        const validFields = [tallVal, lovVal, granVal, alVal, aspVal, bjorkVal, bokVal, ekVal].filter(
            (value) => !isNaN(value)
        );

        const sum = validFields.reduce((acc, value) => acc + value, 0);

        setErrors(sum !== 100);
    }
    
    {/* Table functions edit and submit new */}
    const handleEditSubmit = (event) => {
        event.preventDefault();
        let updatedData;
        if (errors === false) {
            if (Object.keys(adData.forestWithSections).length > 0) {
                const originalSections = adData.forestWithSections.sections;
                const updatedSections = originalSections.map((section) => {
                    if (selectedSection == section.Name) {
                        const updatedTGL = {
                            "Tall": tall / 100,
                            "Gran": gran / 100,
                            "default": lov / 100,
                            ...(al != null && al !== 0 && al !== '' && !isNaN(al) ? { "Al": al / 100 } : {}),
                            ...(asp != null && asp !== 0 && asp !== '' && !isNaN(asp) ? { "Asp": asp / 100 } : {}),
                            ...(björk != null && björk !== 0 && björk !== '' && !isNaN(björk) ? { "Björk": björk / 100 } : {}),
                            ...(bok != null && bok !== 0 && bok !== '' && !isNaN(bok) ? { "Bok": bok / 100 } : {}),
                            ...(ek != null && ek !== 0 && ek !== '' && !isNaN(ek) ? { "Ek": ek / 100 } : {}),
                        };
                        const filteredTGL = Object.fromEntries(Object.entries(updatedTGL).filter(([key, value]) => value !== 0));
                        return {
                            ...section,

                            totalVolume: typeof (volume_m3fub) !== 'undefined' && volume_m3fub !== "" ? volume_m3fub : volume,
                            TGL: filteredTGL,
                        };
                    }
                    return section;
                });

                const sectionsChanged = JSON.stringify(updatedSections) !== JSON.stringify(originalSections)
                if (sectionsChanged) {
                    const updatedForestWithSections = {
                        ...adData.forestWithSections,
                        sections: updatedSections,
                    };
                    changeAdData({ forestWithSections: updatedForestWithSections });
                    updatedData = updatedSections
                }

            }
            setEditSectionModal(false)
            setVolumeM3Fub('')
            setTall('')
            setGran('')
            setLov('')
            setFieldSelected('')
            setAl('')
            setAsp('')
            setBjork('')
            setBok('')
            setEk('')

            return;
        }

        else {
            alert('Andel ska vara positiv och summan av TGL 100')
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (errors === false) {
            const updatedTGL = {
                "Tall": (tall !== undefined && tall !== null) ? tall / 100 : 0,
                "Gran": (gran !== undefined && gran !== null) ? gran / 100 : 0,
                "default": (lov !== undefined && lov !== null) ? lov / 100 : 0,
                ...(al !== null && !isNaN(al) ? { "Al": al / 100 } : {}),
                ...(asp !== null && !isNaN(asp) ? { "Asp": asp / 100 } : {}),
                ...(björk !== null && !isNaN(björk) ? { "Björk": björk / 100 } : {}),
                ...(bok !== null && !isNaN(bok) ? { "Bok": bok / 100 } : {}),
                ...(ek !== null && !isNaN(ek) ? { "Ek": ek / 100 } : {}),
            };
            const filteredTGL = Object.fromEntries(Object.entries(updatedTGL).filter(([key, value]) => value !== 0));
            const newSection = {
                Name: (avdelningsnr !== undefined && avdelningsnr !== null) ? avdelningsnr : adData.forestWithSections.sections.length + 1,
                Hectares: (area !== undefined && area !== null) ? area : "1",
                totalVolume: (volume_m3fub_new !== undefined && volume_m3fub_new !== null) ? gallring ? Math.round(parseFloat(volume_m3fub_new) * 0.3) : volume_m3fub_new : 0,
                TGL: filteredTGL
            }
            let updatedForestWithSections;

            const updatedSections = [...adData.forestWithSections.sections, newSection]
            updatedForestWithSections = { ...adData.forestWithSections, sections: updatedSections }
            changeAdData({ forestWithSections: updatedForestWithSections })

            setAddSectionModal(false)
            setAvdelningsnr('')
            setArea('')
            setVolumeM3FubNew('')
            setTall('')
            setGran('')
            setLov('')
            setFieldSelected('')
            setAl('')
            setAsp('')
            setBjork('')
            setBok('')
            setEk('')
        }
        else {
            alert('Vänligen fyll i alla fält för att fortsätta')
        }
    }
    
    const handleDeleteSection = () => {
        if (Object.keys(adData.forestWithSections).length > 0) {
            const updatedSections = adData.forestWithSections.sections.filter((section) => {
                return section.Name !== selectedSection
            })
            const updatedForestWithSections = { ...adData.forestWithSections, sections: updatedSections }
            changeAdData({ forestWithSections: updatedForestWithSections })
            setDeleteSectionModal(false)
        }
    }



    return (
        <div className='' data-step='2'>
            <div className='row justify-content-between d-flex'>
                <div className='col-lg-4 col-8 position-relative rounded shadow p-2 m-4'>
                    <p className="fw-medium m-2">{adData.description_of_property}</p>
                    <p className="m-2 fw-medium"> {capitalizeFirstLetter(adData.arrangement)}</p>
                </div>
                <div className='col-lg-4 col-10 rounded-3 bg-neutral-stone-300 p-3 ms-3 me-1 mb-3'>
                    <p className='neutral-charcoal mb-0'>I kartan nedan kan du se de områdena du valde i förra steget, under kartan kan du redigera de hämtade skogsuppgifterna för områdena.</p>
                </div>
            </div>
            <div className='position-relative' style={{ height: '500px' }}>
                <VBLeaflet ref={mapRef} id='map_auctions' baseMap='Mapbox Satelite' />
                <ZoomAndLayerButtons mapRef={mapRef} mapTools={mapTools} setMapTools={(val) => { setMapTools(val) }} />
                {mapTools && <LayerSelector mapRef = {mapRef} mapTools={mapTools} setMapTools = {(val)=>{setMapTools(val)}} setRefresh={(val)=>setRefresh(val)}/>}
            </div>
            <div className='rounded-4 bg-neutral-cloud-300 neutral-charcoal p-2 p-lg-4 mb-3 mt-5'>
                <h5 className='fw-medium n-fs-5 neutral-charcoal mt-3'>Virkesinformation</h5>
                <p>Nedan information är hämtad från senaste lasterdatan. Klicka på de tre punkterna till höger om varje rad för att Redigera/Radera.</p>
                <p>Notera att volym och trädslag behöver inte vara 100% rätt för din annons, utan säkerställ bara att det stämmer ganska bra.</p>
                <button className="n-btn btn-core btn-sm" onClick={() => {
                    setAddSectionModal(true);
                    setAvdelningsnr(''); 
                    setArea(0); 
                    setVolumeM3FubNew(0); 
                    setTall(0); setGran(0); setLov(0); 
                    setAl(0); setAsp(0); setBjork(0); setBok(0); setEk(0);
                }}>
                    <img src={Window.static_path + "img/icons/icon-left-dark.svg"} className="pe-2" alt="Add icon" />Lägg till avdelning
                </button>
                <div className='table-responsive'>
                    <table className="table table-borderless table-striped position-relative">
                        <thead className="position-sticky bg-neutral-cloud-300" style={{ "top": "-30px", "height": "60px" }}>
                            <tr>
                                <th className='fw-medium neutral-charcoal' scope="col">Avd # </th>
                                <th className='fw-medium neutral-charcoal' scope="col">Areal</th>
                                <th className='fw-medium neutral-charcoal text-nowrap' scope='col'>{gallring ? 'Uttag*' : 'Uttag'}</th>
                                <th className='fw-medium neutral-charcoal' scope='col'>Tall</th>
                                <th className='fw-medium neutral-charcoal' scope='col'>Gran</th>
                                <th className='fw-medium neutral-charcoal' scope='col'>Löv</th>
                                {currentSectionData.some(itm => itm.data.al !== null && !isNaN(itm.data.al)) && <th className='fw-medium neutral-charcoal' scope='col'>Al</th>}
                                {currentSectionData.some(itm => itm.data.asp !== null && !isNaN(itm.data.asp)) && <th className='fw-medium neutral-charcoal' scope='col'>Asp</th>}
                                {currentSectionData.some(itm => itm.data.björk !== null && !isNaN(itm.data.björk)) && <th className='fw-medium neutral-charcoal' scope='col'>Björk</th>}
                                {currentSectionData.some(itm => itm.data.bok !== null && !isNaN(itm.data.bok)) && <th className='fw-medium neutral-charcoal' scope='col'>Bok</th>}
                                {currentSectionData.some(itm => itm.data.ek !== null && !isNaN(itm.data.ek)) && <th className='fw-medium neutral-charcoal' scope='col'>Ek</th>}
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentSectionData.map((itm, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <tr>
                                            <td>{"#" + (itm.data.name)}</td>
                                            <td>{Math.round(itm.data.area * 10) / 10} ha</td>
                                            <td>{`${itm.data.volume_m3fub} m³fub`}</td>
                                            <td>{isNaN(itm.data.tall) ? 0 : Math.round(itm.data.tall * 100)}%</td>
                                            <td>{isNaN(itm.data.gran) ? 0 : Math.round(itm.data.gran * 100)}%</td>
                                            <td>{isNaN(itm.data.lov) ? 0 : Math.round(itm.data.lov * 100)}%</td>
                                            {currentSectionData.some(itm => itm.data.al !== null && !isNaN(itm.data.al)) && <td>{isNaN(itm.data.al) ? '' : Math.round(itm.data.al * 100)}%</td>}
                                            {currentSectionData.some(itm => itm.data.asp !== null && !isNaN(itm.data.asp)) && <td>{isNaN(itm.data.asp) ? '' : Math.round(itm.data.asp * 100)}%</td>}
                                            {currentSectionData.some(itm => itm.data.björk !== null && !isNaN(itm.data.björk)) && <td>{isNaN(itm.data.björk) ? '' : Math.round(itm.data.björk * 100)}%</td>}
                                            {currentSectionData.some(itm => itm.data.bok !== null && !isNaN(itm.data.bok)) && <td>{isNaN(itm.data.bok) ? '' : Math.round(itm.data.bok * 100)}%</td>}
                                            {currentSectionData.some(itm => itm.data.ek !== null && !isNaN(itm.data.ek)) && <td>{isNaN(itm.data.ek) ? '' : Math.round(itm.data.ek * 100)}%</td>}
                                            <td><div className='position-relative'>
                                                <button className='n-btn btn-ghost btn-charcoal btn-sm' onClick={(e) => handleMenuClick(i, e)}>
                                                    <img src={Window.static_path + "img/icons/three-dots-vertical.svg"} role='button' alt="Menu" />
                                                </button>
                                                {isMenuRowOpen === i && (
                                                    <div ref={menuRef} className='bg-white rounded-1 p-2 position-absolute translate-middle-x' style={{ zIndex: 1, top: "-50%", left: "-50%" }}>
                                                        <button className='n-btn btn-ghost btn-core d-flex justify-content-center' onClick={() => {
                                                            setEditSectionModal(true);
                                                            setSelectedSection(itm.data.id);
                                                            setVolume(Math.round(itm.data.volume));
                                                            setVolumeM3Fub(Math.round(itm.data.volume_m3fub));
                                                            setTall(isNaN(itm.data.tall) ? 0 : Math.round(itm.data.tall * 100));
                                                            setGran(isNaN(itm.data.gran) ? 0 : Math.round(itm.data.gran * 100));
                                                            setLov(isNaN(itm.data.lov) ? 0 : Math.round(itm.data.lov * 100));
                                                            setAl(isNaN(itm.data.al) ? 0 : Math.round(itm.data.al * 100));
                                                            setAsp(isNaN(itm.data.asp) ? 0 : Math.round(itm.data.asp * 100));
                                                            setBjork(isNaN(itm.data.björk) ? 0 : Math.round(itm.data.björk * 100));
                                                            setBok(isNaN(itm.data.bok) ? 0 : Math.round(itm.data.bok * 100));
                                                            setEk(isNaN(itm.data.ek) ? 0 : Math.round(itm.data.ek * 100));
                                                            setFieldSelected(
                                                                fields.filter(field => itm.data[field.id] !== null && !isNaN(itm.data[field.id]))
                                                            );
                                                            setErrors(false);
                                                        }}>
                                                            <span className='me-1'><img src={Window.static_path + "img/icons/pencil.svg"} role='button' alt="Edit" /></span><span>Redigera</span>
                                                        </button>
                                                        <button className='n-btn btn-ghost btn-charcoal d-flex justify-content-center' onClick={() => { setDeleteSectionModal(true); setSelectedSection(itm.data.id); }}>
                                                            <span className='me-1'><img src={Window.static_path + "img/icons/bin.svg"} role='button' alt="Delete" /></span><span>Radera</span>
                                                        </button>
                                                    </div>
                                                )}
                                            </div></td>
                                        </tr>
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            {gallring && <p className="mt-0 mb-2 neutral-charcoal n-fs-7">*Observera att volymen på nya avdelningar automatiskt reduceras till 30% pga Gallringsuppdrag. För att ändra volymen till valfritt värde klickar du på Redigera.</p>}

            {/* Edit Section Modal */}
            <Modal show={editSectionModal} onHide={() => {setEditSectionModal(false);setFieldSelected([]);setErrors(false);}} size="md" contentClassName="bg-white p-2" centered>
                <Modal.Header className="align-items-start border-0" closeButton>
                    <h4 className='neutral-charcoal fs-5'>Redigera avsnitt</h4>
                </Modal.Header>
                <Modal.Body className="py-0 rounded-4 my-2 pb-1">
                    <form onSubmit={handleEditSubmit}>
                        <div className="row align-items-center g-0 p-2">
                            <div className="col-6 p-2">Totalvolym (m³sk)</div>
                            <div className="col-6 p-2">
                                <VBInput
                                    initial={volume ? Math.round(parseFloat(volume) / 0.83) : 0}
                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                    type="number"
                                    onChange={(val) => {
                                        val = val.replace(".", "");
                                        const newVolumeM3Fub = Math.round(parseFloat(val) * 0.83);
                                        setVolume(val);
                                        setVolumeM3Fub(newVolumeM3Fub);
                                        if (volumeM3FubInputRef.current) {
                                            volumeM3FubInputRef.current.setValue(newVolumeM3Fub);
                                        }
                                    }}
                                    ref={volumeM3skInputRef}
                                />
                            </div>
                            <div className="col-6 p-2">Totalvolym (m³fub)</div>
                            <div className="col-6 p-2">
                                <VBInput
                                    initial={volume_m3fub ? volume_m3fub : 0}
                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                    type="number"
                                    onChange={(val) => {
                                        val = val.replace(".", "");
                                        const newVolume = Math.round(parseFloat(val) / 0.83);
                                        setVolume(newVolume);
                                        setVolumeM3Fub(val);
                                        if (volumeM3skInputRef.current) {
                                            volumeM3skInputRef.current.setValue(newVolume);
                                        }
                                    }}
                                    ref={volumeM3FubInputRef}
                                />
                            </div>

                            <div className="col-6 p-2">Tall|Gran|Löv</div>
                            <div className="col-6 p-2">TGL %</div>

                            <div className="col-6 p-2">Tall %</div>
                            <div className="col-6 p-2">
                                <VBInput
                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                    initial={isNaN(tall) ? 0 : tall}
                                    type="number"
                                    error={errors ? "Andel ska vara positiv och summan av TGL 100" : null}
                                    onChange={(val) => { setTall(val); }}
                                />
                            </div>

                            <div className="col-6 p-2">Gran %</div>
                            <div className="col-6 p-2">
                                <VBInput
                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                    initial={isNaN(gran) ? 0 : gran}
                                    type="number"
                                    error={errors ? "Andel ska vara positiv och summan av TGL 100" : null}
                                    onChange={(val) => { setGran(val); }}
                                />
                            </div>

                            <div className="col-6 p-2">Löv %</div>
                            <div className="col-6 p-2">
                                <VBInput
                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                    initial={isNaN(lov) ? 0 : lov}
                                    type="number"
                                    error={errors ? "Andel ska vara positiv och summan av TGL 100" : null}
                                    onChange={(val) => { setLov(val); }}
                                />
                            </div>
                            <VBMultiOption
                                inputStyle={{ minHeight: 0 }}
                                placeholder="Lägg till fler trädslag"
                                label={<p className='mb-1 mt-3'>Lägg till fler trädslag?</p>}
                                options={fields}
                                autoClose={true}
                                onChange={(val) => { setFieldSelected(val); }}
                                selected={fieldSelected}
                            />

                            {fields.map((field) => (
                                <React.Fragment key={field.id}>
                                    {fieldSelected && fieldSelected.some(selectedField => selectedField.id === field.id) && (
                                        <>
                                            <div className="col-6 p-2">{field.label} %</div>
                                            <div className="col-6 p-2">
                                                <VBInput
                                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                                    initial={isNaN(eval(field.id)) ? '' : eval(field.id)} // Eval for dynamic state property
                                                    type="number"
                                                    error={errors ? "Andel ska vara positiv och summan av TGL 100" : null}
                                                    onChange={(val) => {
                                                        switch (field.id) {
                                                            case 'al': setAl(val); break;
                                                            case 'asp': setAsp(val); break;
                                                            case 'björk': setBjork(val); break;
                                                            case 'bok': setBok(val); break;
                                                            case 'ek': setEk(val); break;
                                                            default: break;
                                                        }
                                                        setTimeout(() => { validateTGL(); }, 1000);
                                                    }}
                                                />
                                            </div>
                                        </>
                                    )}
                                </React.Fragment>
                            ))}


                            <div className="mt-4 row justify-content-center">
                                <div className='col-12 col-md-6'>
                                    <button className='n-btn btn-forest-green w-100' type="submit">Spara</button>
                                </div>
                                <div className='col-12 col-md-6'>
                                    <button type="button" className="n-btn btn-outline btn-charcoal w-100 mt-1 mt-md-0" onClick={() => {
                                        setEditSectionModal(false);
                                        setFieldSelected([]);
                                        setErrors(false);
                                    }}>Stäng</button>
                                </div>
                            </div>
                        </div>
                    </form>

                </Modal.Body>
            </Modal>

            {/* Add Section Modal */}
            <Modal show={addSectionModal} onHide={() => {setAddSectionModal(false);setFieldSelected([]);setErrors(false);}} size="md" contentClassName="bg-white p-2" centered>
                <Modal.Header className="align-items-start border-0" closeButton>
                    <h4 className='neutral-charcoal fs-5'>Lägg till avdelning</h4>
                </Modal.Header>
                <Modal.Body className="py-0 rounded-4 my-2 pb-1">
                    <form onSubmit={handleSubmit}>
                        <div className="row align-items-center g-0 p-2">
                            <div className="col-6 p-2">Avdelningsnummer</div>
                            <div className="col-6 p-2">
                                <VBInput
                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                    type="number"
                                    initial={avdelningsnr}
                                    onChange={(val) => setAvdelningsnr(val)}
                                />
                            </div>
                            <div className="col-6 p-2">Areal (ha)</div>
                            <div className="col-6 p-2">
                                <VBInput
                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                    type="number"
                                    initial={area}
                                    onChange={(val) => setArea(val)}
                                />
                            </div>
                           <div className="col-6 p-2">Totalvolym (m³sk)</div>
                            <div className="col-6 p-2">
                                <VBInput
                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                    type="number"
                                    onChange={(val) => {
                                        val = val.replace(".", "");
                                        const newVolumeM3Fub = Math.round(parseFloat(val) * 0.83);
                                        setVolumeNew(val);
                                        setVolumeM3FubNew(newVolumeM3Fub);
                                        if (volumeM3FubInputNewRef.current) {
                                            volumeM3FubInputNewRef.current.setValue(newVolumeM3Fub);
                                        }
                                    }}
                                    ref={volumeM3skInputNewRef}
                                />
                            </div>
                            <div className="col-6 p-2">Totalvolym (m³fub)</div>
                            <div className="col-6 p-2">
                                <VBInput
                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                    type="number"
                                    onChange={(val) => {
                                        val = val.replace(".", "");
                                        const newVolume = Math.round(parseFloat(val) / 0.83);
                                        setVolumeNew(newVolume);
                                        setVolumeM3FubNew(val);
                                        if (volumeM3skInputNewRef.current) {
                                            volumeM3skInputNewRef.current.setValue(newVolume);
                                        }
                                    }}
                                    ref={volumeM3FubInputNewRef}
                                />
                            </div>

                            <div className="col-6 p-2">Tall|Gran|Löv</div>
                            <div className="col-6 p-2">TGL %</div>

                            <div className="col-6 p-2">Tall %</div>
                            <div className="col-6 p-2">
                                <VBInput
                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                    initial={isNaN(tall) ? 0 : tall}
                                    type="number"
                                    error={errors ? "Andel ska vara positiv och summan av TGL 100" : null}
                                    onChange={(val) => { setTall(val); }}
                                />
                            </div>

                            <div className="col-6 p-2">Gran %</div>
                            <div className="col-6 p-2">
                                <VBInput
                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                    initial={isNaN(gran) ? 0 : gran}
                                    type="number"
                                    error={errors ? "Andel ska vara positiv och summan av TGL 100" : null}
                                    onChange={(val) => { setGran(val); }}
                                />
                            </div>

                            <div className="col-6 p-2">Löv %</div>
                            <div className="col-6 p-2">
                                <VBInput
                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                    initial={isNaN(lov) ? 0 : lov}
                                    type="number"
                                    error={errors ? "Andel ska vara positiv och summan av TGL 100" : null}
                                    onChange={(val) => { setLov(val); }}
                                />
                            </div>
                            <VBMultiOption
                                inputStyle={{ minHeight: 0 }}
                                placeholder="Lägg till fler trädslag"
                                label={<p className='mb-1 mt-3'>Lägg till fler trädslag?</p>}
                                options={fields}
                                autoClose={true}
                                onChange={(val) => { setFieldSelected(val); }}
                                selected={fieldSelected}
                            />

                            {fields.map((field) => (
                                <React.Fragment key={field.id}>
                                    {fieldSelected && fieldSelected.some(selectedField => selectedField.id === field.id) && (
                                        <>
                                            <div className="col-6 p-2">{field.label} %</div>
                                            <div className="col-6 p-2">
                                                <VBInput
                                                    inputStyle={{ minHeight: 0, paddingTop: "5px", paddingBottom: "5px", borderStyle: "groove" }}
                                                    initial={isNaN(eval(field.id)) ? '' : eval(field.id)}
                                                    type="number"
                                                    error={errors ? "Andel ska vara positiv och summan av TGL 100" : null}
                                                    onChange={(val) => {
                                                        switch (field.id) {
                                                            case 'al': setAl(val); break;
                                                            case 'asp': setAsp(val); break;
                                                            case 'björk': setBjork(val); break;
                                                            case 'bok': setBok(val); break;
                                                            case 'ek': setEk(val); break;
                                                            default: break;
                                                        }
                                                        setTimeout(() => { validateTGL(); }, 1000);
                                                    }}
                                                />
                                            </div>
                                        </>
                                    )}
                                </React.Fragment>
                            ))}

                            <div className="mt-4 row justify-content-center">
                                <div className='col-12 col-md-6'>
                                    <button className='n-btn btn-forest-green w-100' type="submit">Spara</button>
                                </div>
                                <div className='col-12 col-md-6'>
                                    <button type="button" className="n-btn btn-outline btn-charcoal w-100 mt-1 mt-md-0" onClick={() => {
                                        setAddSectionModal(false);
                                        setFieldSelected([]);
                                        setErrors(false);
                                    }}>Stäng</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            {/* Delete Section Modal */}
            <Modal show={deleteSectionModal} onHide={() => setDeleteSectionModal(false)} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Bekräfta radering</Modal.Title>
                </Modal.Header>
                <Modal.Body>Är du säker på att du vill radera avdelning #{selectedSection}?</Modal.Body>
                <Modal.Footer>
                    <button className="n-btn btn-outline-danger" onClick={() => setDeleteSectionModal(false)}>Avbryt</button>
                    <button className="n-btn btn-danger" onClick={handleDeleteSection}>Radera</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
export default Step2;